export enum SurveyResponseTypes {
  unknown = 0,
  self = 1,
  benchmark = 2,
  other = 3
}
